import React from 'react';

import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { ExpandableMenuItemContent, ExpandableMenuItemTrigger } from '@atlassian/navigation-system';
import { useFormattedMessageAndIcon } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx';

import { Nav4ExpandableMenuItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/nav4-expandable-menu-item/index.tsx';
import { Nav4MenuLinkItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import messages from '../common/content/message.tsx';
import type { Props } from './types.tsx';

export type Nav4CommunicationsProps = {
	isExpanded?: boolean;
};

export const Nav4Communications = ({ isExpanded = false }: Props) => {
	const { icon: stakeholdersIcon, formattedMessage: stakeholdersMessage } =
		useFormattedMessageAndIcon(messages.stakeholders, PeopleGroupIcon);

	return (
		<Nav4ExpandableMenuItem menuId={messages.communication.id} isExpanded={isExpanded}>
			<ExpandableMenuItemTrigger testId={messages.communication.id}>
				{messages.communication.defaultMessage}
			</ExpandableMenuItemTrigger>
			<ExpandableMenuItemContent>
				<Nav4MenuLinkItem menuId={messages.stakeholders.id} href="/" elemBefore={stakeholdersIcon}>
					{stakeholdersMessage}
				</Nav4MenuLinkItem>
			</ExpandableMenuItemContent>
		</Nav4ExpandableMenuItem>
	);
};
